export const WalkIcon = ({ width, height }: { width?: number; height?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "13"}
    height={height || "18"}
    viewBox="0 0 13 18"
    fill="none"
  >
    <path
      d="M12.78 9.71C12.58 10.11 12.09 10.27 11.7 10.07L8.98998 8.71C8.86998 8.65 8.75998 8.55 8.67998 8.44L7.41998 6.55L7.01998 11.11L8.75998 12.91C8.83998 13 8.90998 13.1 8.93998 13.21L10.11 16.68C10.25 17.1 10.02 17.56 9.59998 17.7C9.51998 17.73 9.42998 17.74 9.33998 17.74C8.99998 17.74 8.68998 17.53 8.57998 17.19L7.46998 13.89L5.83998 12.21L5.29998 14.29C5.26998 14.43 5.18998 14.55 5.09998 14.65L2.31998 17.51C2.00998 17.83 1.49998 17.84 1.17998 17.52C0.859978 17.21 0.849977 16.7 1.15998 16.38L3.78998 13.67L4.47998 11.02C4.12998 10.66 3.94998 10.15 3.99998 9.63L4.33998 6.3L3.18998 7.29L3.01998 10.66C2.99998 11.09 2.63998 11.43 2.20998 11.43H2.16998C1.72998 11.41 1.37998 11.03 1.39998 10.58L1.58998 6.87C1.59998 6.65 1.69998 6.44 1.86998 6.3L4.27998 4.22C4.42998 4.09 4.60998 4.03 4.80998 4.03H7.21998C7.48998 4.03 7.73998 4.16 7.88998 4.39L9.88998 7.37L12.41 8.64C12.81 8.84 12.97 9.32 12.77 9.72L12.78 9.71Z"
      fill="#BAFD4F"
    />
    <path
      d="M6.41922 3.11999C7.23108 3.11999 7.88922 2.46185 7.88922 1.64999C7.88922 0.838134 7.23108 0.179993 6.41922 0.179993C5.60736 0.179993 4.94922 0.838134 4.94922 1.64999C4.94922 2.46185 5.60736 3.11999 6.41922 3.11999Z"
      fill="#BAFD4F"
    />
  </svg>
)
